import React from "react";
import PropTypes from "prop-types";
import { Col, FormSelect } from "shards-react";

const TargetFilterInput = props => {
    const { targets, onTargetChanged } = props;

    return (
        <Col sm="12" lg="6">
            <FormSelect
                className="mb-4 w-25 cypress--select-target"
                onChange={e => onTargetChanged(e.target.value)}
            >
                <option value={"default"}>Todas as Applications</option>
                {targets.map((target, i) => (
                    <option
                        className={`cypress--select-${target.name}`}
                        key={i}
                        value={target.name}
                    >
                        {target.name}
                    </option>
                ))}
            </FormSelect>
        </Col>
    );
};

TargetFilterInput.propTypes = {
    targets: PropTypes.array,
    onTargetChanged: PropTypes.func
};

export default TargetFilterInput;
